function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 0.5625C6.75 0.257812 7.00781 0 7.3125 0H11.4375C11.7422 0 12 0.257812 12 0.5625V4.6875C12 4.99219 11.7422 5.25 11.4375 5.25C11.1328 5.25 10.875 4.99219 10.875 4.6875V1.92188L5.46094 7.33594C5.25 7.54688 4.89844 7.54688 4.66406 7.33594C4.45312 7.125 4.45312 6.75 4.66406 6.53906L10.0781 1.125H7.3125C7.00781 1.125 6.75 0.867188 6.75 0.5625ZM1.875 2.25H3.9375C4.24219 2.25 4.5 2.50781 4.5 2.8125C4.5 3.11719 4.24219 3.375 3.9375 3.375H1.875C1.45312 3.375 1.125 3.70312 1.125 4.125V10.125C1.125 10.5469 1.45312 10.875 1.875 10.875H7.875C8.29688 10.875 8.625 10.5469 8.625 10.125V8.0625C8.625 7.75781 8.88281 7.5 9.1875 7.5C9.49219 7.5 9.75 7.75781 9.75 8.0625V10.125C9.75 11.1562 8.90625 12 7.875 12H1.875C0.84375 12 0 11.1562 0 10.125V4.125C0 3.09375 0.84375 2.25 1.875 2.25Z",
  fill: "#006CA3"
});

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.a2bcfee2.svg";
export { ForwardRef as ReactComponent };